import { levelMapScene } from "@kit/map";
import { track } from "@kit/telemetry";
import { meta } from "./meta";
import { DuvarScene } from "./DuvarScene";
import { sizeFor } from "./core/generator";

const DuvarMap = levelMapScene({
  id: "duvar",
  gameScene: "duvar",
  title: { tr: "Duvar", en: "Wall" },
  accent: 0x6a4c93,
  firstTheme: 4,
  track,
  describe: (n, lang) => {
    const { w, h, d } = sizeFor(n);
    return lang === "tr"
      ? `${w}×${h} duvar · ${d} katman · resmin %40'ı açılmadan bil: 3 yıldız`
      : `${w}×${h} wall · ${d} layer${d > 1 ? "s" : ""} · guess before 40% shows for 3 stars`;
  },
});

/** Embeddable game contract (docs/design/platform.md). The level itself renders with three.js. */
export const game = { meta, scenes: [DuvarMap, DuvarScene] };
